document.addEventListener('alpine:init', () => {
  const baseSpendBarWidth = document.querySelector(".spend-progress-wrapper")?.offsetWidth || 0;
  const iconWidth = document.querySelector(".spend-progress-truck")?.offsetWidth || 0;

  Alpine.store("spendProgress", {
    totalPrice: 0,
    successMessage: "",
    progressMessage: "",
    currentShippingCost: 15,
    tiers: [],
    defaultShippingTier: {},
    freeShippingTier: {},
    hasShippingLocation: false,
    shippingZoneData: null,
    savedSuburb: "",
    savedPostcode: "",
    init() {
      this.$watch && this.$watch("totalPrice", this.onTotalPriceChange.bind(this));
      // Check if shipping location cookie exists
      this.checkShippingLocation();
      
      // Listen for shipping location updates from the modal
      window.addEventListener('shippingLocationUpdated', (e) => {
        this.checkShippingLocation();
      });
    },
    checkShippingLocation() {
      const location = window.getShippingLocationCookie();
      this.hasShippingLocation = !!(location && location.zone);
      this.savedSuburb = (location && location.suburb) ? location.suburb : "";
      this.savedPostcode = (location && location.postcode) ? location.postcode : "";

      if (this.hasShippingLocation) {
        // Load zone data from CSV
        this.loadZoneData(location.zone);
      }
    },
    loadZoneData(zoneName) {
      const zonesUrl = window.getValueOrDefault('data-shipping-zones-csv-url', 'https://cdn.shopify.com/s/files/1/2576/4222/files/rnf_becool_zones.csv?v=1769750851');
      
      if (!zonesUrl || !window.Papa) return;
      
      Papa.parse(zonesUrl, {
        download: true,
        header: true,
        complete: (results) => {
          const zoneData = results.data.find(z => z.zone === zoneName && z.available?.toUpperCase() === 'TRUE');
          
          if (zoneData) {
            this.shippingZoneData = zoneData;
            // Trigger recalculation with zone-based thresholds
            this.onTotalPriceChange();
          }
        },
        error: (error) => {
          console.error('Error loading zone data:', error);
        }
      });
    },
    applyDifference(tier, text, centsBehavior = 'hide-cents') {
      const threshold = tier.threshold * 100;
      return text.replace('[difference]', window.toMoneyFormat((threshold - this.totalPrice) / 100, centsBehavior));
    },
    refreshTiers() {
      // If we have zone data, use zone-based thresholds
      if (this.hasShippingLocation && this.shippingZoneData) {
        const baseCost = parseFloat(this.shippingZoneData.base_cost);
        const discountThreshold = parseFloat(this.shippingZoneData.discount_threshold);
        const freeThreshold = parseFloat(this.shippingZoneData.free_threshold);
        
        // Create dynamic tiers based on zone data
        // Tier 1: order >= discount_threshold and < free_threshold -> $8
        // Tier 2: order >= free_threshold -> FREE
        this.tiers = [
          {
            threshold: discountThreshold,
            shipping_price: 8, // $8 (dollars)
            success_message: "$8 shipping!",
            progress_message: "Spend [difference] more for $8 shipping"
          },
          {
            threshold: freeThreshold,
            shipping_price: 0,
            success_message: "You've got FREE shipping!",
            progress_message: "Spend [difference] more for FREE shipping"
          }
        ];
        
        // Default: order under discount_threshold -> base_cost (zone-specific, in dollars)
        this.defaultShippingTier = {
          threshold: 0,
          shipping_price: baseCost
        };
        
        this.freeShippingTier = this.tiers[1];
        return;
      }
      
      // Fall back to original tier system from section config
      const configType = Alpine.store("cart").hasOnlyNonRefrigeratedProducts() ? "nr" : "any";
      const dataAttr = `data-spend-progress-tiers-${configType}-json`;

      const baseTiers = getScriptJSONOrFail(dataAttr);
      this.defaultShippingTier = baseTiers.find(t => t.threshold<= 0);
      this.tiers = baseTiers.sort(function(a, b) {
        return a.threshold - b.threshold;
      }).filter(t => t.threshold > 0);
      
      this.freeShippingTier = this.tiers.find(t => t.shipping_price == 0 && t.threshold > 0)      
    },
    onTotalPriceChange() {
      this.refreshTiers();

      this.progressMessage = "";
      this.successMessage = "";
      this.currentShippingCost = this.defaultShippingTier
        ? this.defaultShippingTier.shipping_price
        : 15; // Default $15 in cents

      let tiersPassed = 1;
      for (const tier of this.tiers) {
        if (this.totalPrice >= tier.threshold * 100) {
          this.successMessage = this.applyDifference(tier, tier.success_message);
          this.currentShippingCost = tier.shipping_price;
        } else {
          this.progressMessage = this.applyDifference(tier, tier.progress_message, 'show');
          break; // our current tier is the tier where we haven't reached the threshold yet
        } tiersPassed++;
      }

      const toFreeShipping = this.totalPrice / (this.freeShippingTier.threshold * 100) * 100;
      const percentToFreeShipping = toFreeShipping > 100
        ? 100
        : toFreeShipping;

      // Notice that adding and removing free active is separated by the width changes.
      // this is to prevent a jittery behavior where the page width may be increased by showing an element
      // that is wider than the screen while the free-active element is shown/hidden
      if (tiersPassed > this.tiers.length) {
        document.querySelector(".spend-progress-wrapper").classList.add("free-active");
      }

      // Change spend-progress-active width to use percentage
      document.getElementById("spend-progress-active").style.width = `calc(${percentToFreeShipping}% - 46px)`;

      // we want to only remove free-active once we ensure that the width is already adjusted
      if (tiersPassed <= this.tiers.length) {
        setTimeout(() => {
          document.querySelector(".spend-progress-wrapper").classList.remove("free-active");
        }, 200);
      }
      Alpine.store("cart").applyComputedValues();
    },
    getShippingCost() {
      return window.toMoneyFormat(this.currentShippingCost, 'hide-cents')
    }
  });

  // initialize by running price change once
  setTimeout(() => {
    Alpine.store("spendProgress").totalPrice = parseInt(getValueOrFail("data-total-price")); // int as this is in cents
    Alpine.store("cart").applyComputedValues();
  }, 500);
});